/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Authentication API
 * An API to use to authenticate users
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AuthenticatedUser,
    AuthenticatedUserFromJSON,
    AuthenticatedUserFromJSONTyped,
    AuthenticatedUserToJSON,
} from './';

/**
 * 
 * @export
 * @interface AuthenticationResponse
 */
export interface AuthenticationResponse {
    /**
     * The session id used during authentication with the external IDP
     * @type {string}
     * @memberof AuthenticationResponse
     */
    sessionId?: string;
    /**
     * The users that was identified by the supplied authentication token
     * @type {Array<AuthenticatedUser>}
     * @memberof AuthenticationResponse
     */
    authenticatedUsers?: Array<AuthenticatedUser>;
}

export function AuthenticationResponseFromJSON(json: any): AuthenticationResponse {
    return AuthenticationResponseFromJSONTyped(json, false);
}

export function AuthenticationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'authenticatedUsers': !exists(json, 'authenticatedUsers') ? undefined : ((json['authenticatedUsers'] as Array<any>).map(AuthenticatedUserFromJSON)),
    };
}

export function AuthenticationResponseToJSON(value?: AuthenticationResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
        'authenticatedUsers': value.authenticatedUsers === undefined ? undefined : ((value.authenticatedUsers as Array<any>).map(AuthenticatedUserToJSON)),
    };
}


